import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["width", "height"]
const _hoisted_2 = ["fill"]

import { withDefaults } from 'vue';

interface IProps {
  color?: string;
  width?: string;
  height?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BRLIcon',
  props: {
    color: {},
    width: { default: '22' },
    height: { default: '17' }
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("svg", {
    width: _ctx.width || 22,
    height: _ctx.height || 17,
    viewBox: "0 0 22 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, [
    _createElementVNode("path", {
      d: "M0.291193 15V1.90909H5.20028C6.20597 1.90909 7.04972 2.08381 7.73153 2.43324C8.41761 2.78267 8.93537 3.27273 9.2848 3.90341C9.63849 4.52983 9.81534 5.26065 9.81534 6.09588C9.81534 6.93537 9.63636 7.66406 9.27841 8.28196C8.92472 8.8956 8.4027 9.37074 7.71236 9.70739C7.02202 10.0398 6.17401 10.206 5.16832 10.206H1.67188V8.23722H4.84872C5.43679 8.23722 5.91832 8.15625 6.29332 7.99432C6.66832 7.82812 6.94531 7.58736 7.12429 7.27202C7.30753 6.95241 7.39915 6.56037 7.39915 6.09588C7.39915 5.63139 7.30753 5.23509 7.12429 4.90696C6.94105 4.57457 6.66193 4.32315 6.28693 4.1527C5.91193 3.97798 5.42827 3.89062 4.83594 3.89062H2.66264V15H0.291193ZM7.05398 9.06818L10.2947 15H7.64844L4.4652 9.06818H7.05398ZM16.0891 16.6364V0.272726H17.1374V16.6364H16.0891ZM19.1126 5.50781C19.0529 4.94957 18.8015 4.51491 18.3583 4.20384C17.9194 3.89276 17.3484 3.73722 16.6452 3.73722C16.1509 3.73722 15.7269 3.81179 15.3732 3.96094C15.0195 4.11008 14.7489 4.3125 14.5614 4.56818C14.3739 4.82386 14.2781 5.11577 14.2738 5.44389C14.2738 5.71662 14.3356 5.95312 14.4592 6.15341C14.587 6.35369 14.7596 6.52415 14.9769 6.66477C15.1942 6.80114 15.435 6.91619 15.6992 7.00994C15.9634 7.10369 16.2298 7.18253 16.4982 7.24645L17.7255 7.55327C18.2198 7.66832 18.695 7.82386 19.1509 8.01989C19.6112 8.21591 20.0224 8.46307 20.3846 8.76136C20.7511 9.05966 21.0408 9.41974 21.2539 9.84162C21.467 10.2635 21.5735 10.7578 21.5735 11.3246C21.5735 12.0916 21.3775 12.767 20.9854 13.3509C20.5934 13.9304 20.0266 14.3842 19.2852 14.7124C18.5479 15.0362 17.6552 15.1982 16.6069 15.1982C15.5884 15.1982 14.7042 15.0405 13.9542 14.7251C13.2085 14.4098 12.6246 13.9496 12.2028 13.3445C11.7852 12.7393 11.5593 12.0021 11.5252 11.1328H13.8583C13.8924 11.5888 14.033 11.968 14.2802 12.2706C14.5273 12.5732 14.8491 12.799 15.2454 12.9482C15.646 13.0973 16.0934 13.1719 16.5877 13.1719C17.1033 13.1719 17.555 13.0952 17.9428 12.9418C18.3349 12.7841 18.6417 12.5668 18.8633 12.2898C19.0849 12.0085 19.1978 11.6804 19.2021 11.3054C19.1978 10.9645 19.0977 10.6832 18.9016 10.4616C18.7056 10.2358 18.4308 10.0483 18.0771 9.89915C17.7276 9.74574 17.3185 9.60937 16.8498 9.49006L15.3604 9.10653C14.2823 8.82955 13.43 8.4098 12.8036 7.8473C12.1815 7.28054 11.8704 6.52841 11.8704 5.59091C11.8704 4.8196 12.0792 4.14418 12.4968 3.56463C12.9187 2.98509 13.4918 2.53551 14.2163 2.21591C14.9407 1.89204 15.761 1.73011 16.6772 1.73011C17.6062 1.73011 18.4201 1.89204 19.119 2.21591C19.8221 2.53551 20.3739 2.98082 20.7745 3.55185C21.1751 4.11861 21.3817 4.7706 21.3945 5.50781H19.1126Z",
      fill: _ctx.color || '#801434'
    }, null, 8, _hoisted_2)
  ], 8, _hoisted_1))
}
}

})